import { useLanguage } from "../i18n/LanguageContext";
import { Beaker, Leaf, Shield, Cpu } from "lucide-react";
import { SEO } from "../components/SEO";

const icons = {
  whyNatural: Leaf,
  whyFormulation: Beaker,
  whyOpen: Shield,
  whyAI: Cpu
};

export const Method = () => {
  const { t, language } = useLanguage();

  const sections = ["whyNatural", "whyFormulation", "whyOpen", "whyAI"];

  return (
    <div className="min-h-screen pt-24 pb-16">
      <SEO page="method" />
      {/* Header */}
      <section className="px-4 sm:px-6 mb-12">
        <div className="max-w-3xl mx-auto text-center">
          <div className="decorative-line mb-4" />
          <h1 
            data-testid="method-title"
            className="font-serif text-4xl sm:text-5xl lg:text-6xl font-medium text-[#2C3329] mb-4 animate-fade-in-up"
          >
            {t.method.title}
          </h1>
          <p className="text-lg text-[#6B7266] animate-fade-in-up animation-delay-200">
            {t.method.subtitle}
          </p>
        </div>
      </section>

      {/* Content Sections */}
      <section className="px-4 sm:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="space-y-5">
            {sections.map((section, index) => {
              const Icon = icons[section];
              return (
                <div 
                  key={section}
                  data-testid={`method-section-${section}`}
                  className={`premium-card p-8 sm:p-10 rounded-xl animate-fade-in-up`}
                  style={{ animationDelay: `${index * 150}ms` }}
                >
                  <div className={`flex ${language === 'he' ? 'flex-row' : 'flex-row'} items-start gap-6`}>
                    <div className="shrink-0 w-14 h-14 rounded-2xl bg-gradient-to-br from-[#4A5D43]/10 to-[#4A5D43]/5 flex items-center justify-center">
                      <Icon className="w-7 h-7 text-[#4A5D43]" />
                    </div>
                    <div className="flex-1">
                      <h2 className="font-serif text-xl sm:text-2xl mb-4 text-[#2C3329]">
                        {t.method.sections[section].title}
                      </h2>
                      <p className="text-[#6B7266] leading-relaxed">
                        {t.method.sections[section].content}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Method;
